window.ActionsManager = Component.extend({

    initialize: function (ids) {
        this.name = "ActionsManager";
        this.actions = new Actions();
    },

    reset: function () {
        this.actions = new Actions();
    },

    setup: function (container) {
        this.container = container;
        this.storage = container.storage;

        this.load();
    },

    canAddAction: function () {
        return this.actions.length < ActionsManager.MAX_ACTIONS;
    },

    addAction: function (action) {
        if (!action) return;
        if (!this.canAddAction()) return false;

        if (action.getId() == null) action.setId(this.getNextId());

        var result = this.actions.add(action, {
            merge: true
        });
        if (result) this.save();

        return result;
    },

    removeAction: function (id) {
        var result = this.actions.remove(id);
        if (result) this.save();

        return result;
    },

    removeSkillAction: function (skillId) {
        var action = this.actions.findWhere({
            skillId: skillId
        });

        return this.removeAction(action.getId());
    },

    getAction: function (pageId) {
        return this.actions.get(pageId);
    },

    getActions: function (filter) {
        return this.actions.where(filter);
    },

    getNextId: function () {
        var last = this.actions.last();
        if (!last) return 0;

        return last.getId() + 1;
    },

    getSkillAction: function (skillId) {
        return this.actions.findWhere({
            skillId: skillId
        });
    },

    isComplete: function () {
        var completedActions = this.actions.where({
            isComplete: true
        });
        if (!completedActions) return false;

        return this.actions.length === completedActions.length;
    },

    save: function () {
        this.storage.setItem(this.name, this.actions, true);
    },

    load: function () {
        var actions = this.storage.getItem(this.name);
        if (actions === -1) return;

        this.actions = new Actions(actions);
    },

    showMinWarningDialog: function () {
        var self = this;

        this.bootbox = new AccessibleBootbox({
            title: LanguageManager.getString('add_action_title'),
            message: LanguageManager.getString('add_action_message'),
            animate: true,
            buttons: {
                ok: {
                    label: LanguageManager.getString('ok'),
                    className: "btn-primary",
                    callback: function () {
                        if (self.bootbox !== undefined) {
                            self.bootbox.destroy();
                        }
                        self.bootbox = undefined;
                    }
                },
            }
        });
        this.bootbox.popIn();
    },

    showMaxWarningDialog: function () {
        var self = this;

        this.bootbox = new AccessibleBootbox({
            title: LanguageManager.getString('max_actions_title'),
            message: LanguageManager.getString('max_actions_message'),
            animate: true,
            buttons: {
                ok: {
                    label: LanguageManager.getString('ok'),
                    className: "btn-primary",
                    callback: function () {
                        if (self.bootbox !== undefined) {
                            self.bootbox.destroy();
                        }
                        self.bootbox = undefined;
                    }
                },
            }
        });
        this.bootbox.popIn();
    },
}, {
    MAX_ACTIONS: 10,
    MIN_ACTIONS: 1,
    MAX_TITLE_LENGTH: 70,
    MAX_NOUN_LENGTH: 50,
    MAX_CUSTOM_LENGTH: 100,
    ACTION_DATA_KEY: "actiondata",
    ACTION_PLAN_CONFIRMED_KEY: "actionplanconfirmed"
});
// module.exports.ActionsManager = ActionsManager;

window.Action = Backbone.Model.extend({
    defaults: {
        id: undefined,
        skillId: undefined,
        title: undefined,
        limit: undefined,
        verb: undefined,
        noun: undefined,
        custom: undefined,
        isComplete: false
    },

    getId: function () {
        return this.get("id");
    },

    getSkillId: function () {
        return this.get("skillId");
    },

    getTitle: function () {
        return this.get("title");
    },

    getLimit: function () {
        return this.get("limit");
    },

    getVerb: function () {
        return this.get("verb");
    },

    getNoun: function () {
        return this.get("noun");
    },

    getCustom: function () {
        return this.get("custom");
    },

    isComplete: function () {
        return this.get("isComplete");
    },

    setId: function (id) {
        return this.set("id", id);
    },

    setSkillId: function (skillId) {
        return this.set("skillId", skillId);
    },

    setTitle: function (title) {
        return this.set("title", title);
    },

    setLimit: function (limit) {
        return this.set("limit", limit);
    },

    setVerb: function (verb) {
        return this.set("verb", verb);
    },

    setNoun: function (noun) {
        return this.set("noun", noun);
    },

    setCustom: function (custom) {
        return this.set("custom", custom);
    },

    setComplete: function (isComplete) {
        return this.set("isComplete", isComplete);
    }
});
// module.exports.Action = Action;

window.Actions = Backbone.Collection.extend({
    model: Action
});
// module.exports.Actions = Actions;